/** @jsx jsx */
import PropTypes from 'prop-types'
import { Flex, jsx } from 'theme-ui'
import CollapsiblePanel from '~/components/Generic/CollapsiblePanel'
import { useTranslate } from '@arfabrands/gatsby-theme-assembly'

const ProductIngredients = ({ ingredients, titleColor, initiallyCollapsed = true }) => {
  const translate = useTranslate()

  return (
    <Flex
      sx={{
        borderColor: titleColor,
        borderBottomStyle: 'solid',
        borderTopStyle: 'solid',
        borderWidth: '1px',
        py: 1,
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
          maxWidth: '100%'
        }
      }}
    >
      <CollapsiblePanel
        title={translate('product.ingredients_list')}
        titleColor={titleColor}
        initiallyCollapsed={initiallyCollapsed}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: ingredients.childMarkdownRemark.html
          }}
        />
      </CollapsiblePanel>
    </Flex>
  )
}

ProductIngredients.propTypes = {
  ingredients: PropTypes.shape({}),
  titleColor: PropTypes.string,
}

export default ProductIngredients
